import { render, staticRenderFns } from "./kitchenPanel.vue?vue&type=template&id=fb55adf0&scoped=true&"
import script from "./kitchenPanel.vue?vue&type=script&lang=js&"
export * from "./kitchenPanel.vue?vue&type=script&lang=js&"
import style0 from "./kitchenPanel.vue?vue&type=style&index=0&id=fb55adf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb55adf0",
  null
  
)

export default component.exports